var THREE         = require("three");
var RadialHandleView  = require("./radialHandleView.js");
var lib_core      = require("lib-core");

var LocalRotationHandleView = function (model, editorView, handleId, config) {
    RadialHandleView.call(this, model, editorView, handleId, config);
    var self = this;

    this.model.snapped.onChange(this, function(val){
        self.snapChanged(val);
    });

    // this.model.hovered.onChange(this, function(val){
    //     self.snapChanged(false);
    //     self.hover
    // });
}

lib_core.inherit(LocalRotationHandleView, RadialHandleView);

LocalRotationHandleView.prototype.repositionMesh = function(mesh, position){
    console.error("not implimented");
}

LocalRotationHandleView.prototype.buildMesh = function(radius){
    console.error("not implimented");
}

LocalRotationHandleView.prototype.buildGeometry = function(radius){
    var handleSize = this.config.size * (radius/10);
    var handleSpacing = this.extraRadius * (radius/10);
    var shape = new THREE.RingGeometry(
        radius + handleSpacing,
        radius + handleSpacing + handleSize,
        32 );
    return shape;
}


LocalRotationHandleView.prototype.hoverChanged = function(value){
    if(value){
        this.material.transparent = true;
        this.material.opacity = 0.5;
    } else {
        this.material.transparent = true;
        this.material.opacity = 0.3;
    }
} 

LocalRotationHandleView.prototype.snapChanged = function(value){
    if(value){
        this.material.transparent = false;
        this.material.opacity = 1;
    } else {
        this.material.transparent = true;
        this.material.opacity = 0.5;
    }
}

module.exports = LocalRotationHandleView;

